import { render, staticRenderFns } from "./StudentModuleOverview.vue?vue&type=template&id=3703c8bf&scoped=true"
import script from "./StudentModuleOverview.vue?vue&type=script&lang=js"
export * from "./StudentModuleOverview.vue?vue&type=script&lang=js"
import style0 from "./StudentModuleOverview.vue?vue&type=style&index=0&id=3703c8bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3703c8bf",
  null
  
)

export default component.exports